import React from 'react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="border-t border-slate-800 bg-navy-950 pt-20 pb-10" data-id="element-203">
      <div className="max-w-7xl mx-auto px-6" data-id="element-204">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-205">
          <div className="col-span-1 md:col-span-2" data-id="element-206">
            <div className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-mint-500 to-wave-500 mb-4" data-id="element-207">
              Pulsewave
            </div>
            <p className="text-slate-400 text-sm max-w-xs leading-relaxed" data-id="element-208">
              Turn fans into builders who help you win.
            </p>
          </div>

          <div data-id="element-209">
            <div className="font-semibold text-white mb-6" data-id="element-210">Product</div>
            <div className="space-y-3" data-id="element-211">
              <button onClick={() => scrollToSection('demo')} className="block text-slate-400 hover:text-mint-500 transition-colors text-sm" data-id="element-212">
                How it works
              </button>
              <button onClick={() => scrollToSection('program')} className="block text-slate-400 hover:text-mint-500 transition-colors text-sm" data-id="element-213">
                Creator Lab
              </button>
              <button onClick={() => scrollToSection('faq')} className="block text-slate-400 hover:text-mint-500 transition-colors text-sm" data-id="element-214">
                FAQ
              </button>
            </div>
          </div>

          <div data-id="element-215">
            <div className="font-semibold text-white mb-6" data-id="element-216">Support</div>
            <div className="space-y-3" data-id="element-217">
              <a href="mailto:support@pulsewaveco.com" className="block text-slate-400 hover:text-mint-500 transition-colors text-sm" data-id="element-218">
                hello@pulsewaveco.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500" data-id="element-219">
          <div data-id="element-220">
            © Pulsewave {new Date().getFullYear()}. All rights reserved.
          </div>
          <div className="flex gap-6" data-id="element-221">
            <a href="/privacy" onClick={e => {
            e.preventDefault();
            window.location.hash = 'privacy';
          }} className="hover:text-slate-300 transition-colors" data-id="element-222">
              Privacy Policy
            </a>
            <a href="/terms" onClick={e => {
            e.preventDefault();
            window.location.hash = 'terms';
          }} className="hover:text-slate-300 transition-colors" data-id="element-223">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}